import styled from "styled-components";
import { colors, fonts } from "../components/common/mixins";

export const ModalContainer = styled.div`
  text-align: center;
`;

export const ModalTitle = styled.div`
  ${fonts.normalText()}
  color: #000;
  margin-bottom: 24px;
  text-align: left;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  & > a {
    flex-grow: 1;
  }
`;

export const ModalTextCenter = styled.p`
  ${fonts.normalText()}
  color: ${colors.darkBlue};
  margin-bottom: 24px;
`;
